/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Home from '@mui/icons-material/Home';
import DuoIcon from '@mui/icons-material/Duo';
import ChatIcon from '@mui/icons-material/Chat';

export const navigationConfig = customerConfig => [
  {
    title: 'Menu',
    pages: [
      {
        title: 'Home',
        href: '/investigated/dashboard',
        icon: Home,
      },
      {
        title: `Audiência${customerConfig.enableHearingForJuvenileOffenders ? '/Oitiva' : ''}`,
        href: '/investigated/hearing',
        icon: DuoIcon,
      },
      {
        title: 'chat',
        href: '/investigated/chat',
        icon: ChatIcon,
      },
      {
        title: 'Sair',
        href: '/',
        icon: ExitToAppIcon,
      },
    ],
  },
];
